import { render } from "./SelectTypeArtist.vue?vue&type=template&id=6e2cccaf"
import script from "./SelectTypeArtist.vue?vue&type=script&lang=js"
export * from "./SelectTypeArtist.vue?vue&type=script&lang=js"

import "./SelectTypeArtist.vue?vue&type=style&index=0&id=6e2cccaf&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__